import { getSystemList } from "@iewcasia/Services/OrderService";
import setFieldValue from "@iewcasia/Store/Handlers/RfqRequestQuote/SetFieldValue";
import { CustomActions, CustomState } from "@iewcasia/Store/Reducers";
import {
    getRfqFormCheckboxBuilt,
    getRfqFormHintTextBuilt,
    getRfqFormItemsBuilt,
    getRfqFormLabelBuilt,
    OwnProps,
    requestQuoteStyles,
    setRequestFormEffects,
    validateFieldBy,
} from "@iewcasia/Widgets/RfqRequestQuote/FormBaseComponent";
import { RequestQuoteFormContext } from "@iewcasia/Widgets/RfqRequestQuote/RequestForm";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Select from "@insite/mobius/Select";
import * as React from "react";
import { connect, DispatchProp, ResolveThunks } from "react-redux";

const styles = {
    ...requestQuoteStyles.selectFields,
};

const mapStateToProps = (customState: CustomState) => ({
    state: customState.customRequestQuoteForm.fieldValues.state,
    country: customState.customRequestQuoteForm.fieldValues.country,
});

const mapDispatchToProps = {
    setFieldValue,
};

type Props = OwnProps &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    DispatchProp<CustomActions>;

const StateWidget: React.FC<Props> = ({ fields: widgetFields, state, country, setFieldValue: widgetSetFieldValue }) => {
    const { label, hintText, isRequired, items } = widgetFields;
    const [fieldErrorMessage, setFieldErrorMessage] = React.useState("");
    const [stateOptions, setStateOptions] = React.useState([]);
    const { countries } = React.useContext(RequestQuoteFormContext) as any;

    setRequestFormEffects(isRequired, state, "state", () =>
        validateFieldBy(isRequired, label, state, setFieldErrorMessage),
    );

    const fieldChangeHandler = (event: React.ChangeEvent<HTMLSelectElement>) => {
        widgetSetFieldValue({ key: "state", value: event.target.value });
    };

    React.useEffect(() => {
        if (country) {
            widgetSetFieldValue({ key: "state", value: '' });
            const states = countries?.find?.((x: any) => x.name === country)?.states;
            setStateOptions(states?.map?.((x: any) => ({ label: x.name, value: x.name })) || []);
        }
    }, [country]);

    return (
        <Select
            {...styles}
            label={label}
            required={isRequired}
            value={state || ""}
            error={fieldErrorMessage}
            onChange={fieldChangeHandler}
            placeholder={hintText || ""}
        >
             <option value="" {...(isRequired && { disabled: true })}>
                {translate(hintText)}
            </option>
            {stateOptions.map((country: any) => (
                <option key={country.value} value={country.name}>
                    {country.label}
                </option>
            ))}
        </Select>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(StateWidget),
    definition: {
        group: "Request a Quote Form" as any,
        icon: "FormField",
        fieldDefinitions: [
            getRfqFormLabelBuilt("State"),
            getRfqFormHintTextBuilt("Please select"),
            getRfqFormCheckboxBuilt(),
        ],
    },
};

export default widgetModule;
